<template>
  <div class="md:flex flex-wrap lg:flex-no-wrap justify-between">
    <div class="flex md:w-1/2 lg:w-auto mb-8 md:mb-0">
      <img src="@/assets/icons/value1.svg" class="w-15 xl:w-auto h-min-content">
      <div class="pl-8 lg:pl-2 xl:pl-4 md:max-w-48">
        <p class="font-medium text-xl leading-6">
          Qualified and Verified Manufacturers
        </p>
        <p class="mt-2">
          Handpicked & vetted by a team of experts
        </p>
      </div>
    </div>
    <div class="flex md:w-1/2 lg:w-auto mb-8 md:mb-0">
      <img src="@/assets/icons/value2.svg" class="w-15 xl:w-auto h-min-content">
      <div class="pl-8 lg:pl-2 xl:pl-4 md:max-w-44">
        <p class="font-medium text-xl leading-6">
          Transparent Platform Fees
        </p>
        <p class="mt-2">No hidden costs</p>
      </div>
    </div>
    <div class="flex md:w-1/2 lg:w-auto mb-8 md:mb-0">
      <img src="@/assets/icons/value3.svg" class="w-15 xl:w-auto h-min-content">
      <div class="pl-8 lg:pl-2 xl:pl-4 md:max-w-44">
        <p class="font-medium text-xl leading-6">
          Secure<br>Payment
        </p>
        <p class="mt-2">
          Pay with your credit card online
        </p>
      </div>
    </div>
    <div class="flex md:w-1/2 lg:w-auto">
      <img src="@/assets/icons/value4.svg" class="w-15 xl:w-auto h-min-content">
      <div class="pl-8 lg:pl-2 xl:pl-4 md:max-w-48">
        <p class="font-medium text-xl leading-6">
          End to End B2B Sourcing
        </p>
        <p class="mt-2">
          Let us help your company
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CompanyValues',
  data() {
    return {
      values: [
        { icon: 'loop', detail: 'We take accountability for your orders' },
        { icon: 'group', detail: 'Vetted & invited & rated suppliers – no pay for play' },
        { icon: 'credit_card', detail: 'Self-service or full-service solutions to meet your needs' },
        { icon: 'receipt', detail: 'Transparent fees' }
      ]
    }
  },
  methods: {
     getImgUrl(img) {
      return require(`@/assets/icons/${img}`)
    }
  }
}
</script>